module.exports = __webpack_public_path__ + "img/zhuanli.82e08c31.png";